<template>
  <div class="rounded-md bg-green-50 p-4">
    <div class="flex">
      <div class="flex-shrink-0">
        <CheckCircleIcon class="h-5 w-5 text-green-400" aria-hidden="true" />
      </div>
      <div class="ml-3">
        <h3 class="text-sm font-medium text-green-800">
          <slot name='title' />
        </h3>
        <div class="mt-2 text-sm text-green-700" v-if='slots.message'>
          <slot name='message' />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

import { useSlots } from 'vue';
  
import { CheckCircleIcon } from '@heroicons/vue/20/solid';

const slots = useSlots();

</script>